import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { css } from 'styled-components';
export var wordBreak = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  overflow-wrap: break-word;\n  word-break: break-word;\n  word-wrap: break-word;\n"])));